import { render } from "./CustomerEditTicket.vue?vue&type=template&id=c3397ac0&scoped=true"
import script from "./CustomerEditTicket.vue?vue&type=script&lang=js"
export * from "./CustomerEditTicket.vue?vue&type=script&lang=js"

import "./CustomerEditTicket.vue?vue&type=style&index=0&id=c3397ac0&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\Admin_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3397ac0"]])

export default __exports__